export const regexValidationFunc = (pattern, value) => new RegExp(pattern).test(value)

export const validVatMap = {
  SE: /^SE[0-9]{12}$/,
  NO: /^[0-9]{9}MVA$/,
  DK: /^DK[0-9]{8}$/,
  PL: /^PL[0-9]{10}$/,
  FI: /^FI[0-9]{8}$/,
  IT: /^IT[0-9]{11}$/,
  DE: /^DE[0-9]{9}$/,
  FR: /^FR[0-9A-Z]{2}[0-9]{9}$/,
  ES: /^ES[0-9A-Z][0-9]{7}[0-9A-Z]$/,
  GB: /^GB[0-9]{9,12}$/,
  CZ: /^CZ[0-9]{8,10}$/,
  UA: '',
  AT: /^ATU[0-9]{8}$/,
  BE: /^BE[0-9]{10}$/,
  BG: /^BG[0-9]{9,10}$/,
  HR: /^HR[0-9]{11}$/,
  EE: /^EE[0-9]{9}$/,
  EL: /^EL[0-9]{9}$/,
  HU: /^HU[0-9]{8}$/,
  IE: /^IE[0-9A-Z]{8,9}$/,
  LV: /^LV[0-9]{11}$/,
  LT: /^LT([0-9]{9}|[0-9]{12})$/,
  LU: /^LU[0-9]{8}$/,
  MT: /^MT[0-9]{8}$/,
  NL: /^NL[0-9]{9}B[0-9]{2}$/,
  PT: /^PT[0-9]{9}$/,
  CY: /^CY[0-9]{8}L$/,
  RO: /^RO[0-9]{2,10}$/,
  SI: /^SI[0-9]{8}$/,
  SK: /^SK[0-9]{10}$/,
}

export const vatFormats = {
  SE: 'SEXXXXXXXXXXXX',
  NO: 'XXXXXXXXXMVA',
  DK: 'DKXXXXXXXX',
  PL: 'PLXXXXXXXXXX',
  FI: 'FIXXXXXXXX',
  IT: 'ITXXXXXXXXXXX',
  DE: 'DEXXXXXXXXX',
  FR: 'FRXXXXXXXXXXX',
  ES: 'ESXXXXXXXXX',
  GB: 'GBXXXXXXXXX',
  CZ: 'CZXXXXXXXX or CZXXXXXXXXX or CZXXXXXXXXX',
  AT: 'ATUXXXXXXXX',
  BE: 'BEXXXXXXXXXX',
  BG: 'BGXXXXXXXXX or BGXXXXXXXXXX',
  HR: 'HRXXXXXXXXXXX',
  EE: 'EEXXXXXXXXX',
  EL: 'ELXXXXXXXXX',
  HU: 'HUXXXXXXXX',
  IE: 'IEXXXXXXXX or IEXXXXXXXXX',
  LV: 'LVXXXXXXXXXXX',
  LT: 'LTXXXXXXXXX or LTXXXXXXXXXXXX',
  LU: 'LUXXXXXXXX',
  MT: 'MTXXXXXXXX',
  NL: 'NLXXXXXXXXXBXX',
  PT: 'PTXXXXXXXXX',
  CY: 'CYXXXXXXXXX',
  RO: 'ROXXXXXXXXXX',
  SI: 'SIXXXXXXXX',
  SK: 'SKXXXXXXXXXX',
  AU: 'AUXXXXXXXXXX',
}
